"use client";

import dynamic from "next/dynamic";

const CookieConsent = dynamic(
  () =>
    import("@/components/CookieConsent").then((module) => ({
      default: module.CookieConsent,
    })),
  { ssr: false },
);

export const CookieConsentLoader = () => {
  return <CookieConsent />;
};
